






























import Vue from 'vue'
import { CIcon } from '@coreui/icons-vue'
import { cilFolder } from '@coreui/icons-pro'
import '../../styles/folder.css'

export default Vue.extend({
  name: 'Folder',
  data() {
    return {
      folderIcon: cilFolder,
    }
  },
  props: {
    selectedDocuments: {
      type: [],
      required: true,
    },
    folder: {
      type: Object,
      required: true,
    },
    isRoot: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    selectDocument: function (document: any) {
      this.$emit('select-document', document)
    },
  },
  computed: {},
  components: { CIcon },
})
